export const plusIcon = {
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M20 9H0v2h20z"/><path d="M11 20V0H9v20z"/></svg>`,
  name: 'plus',
};
